export default __webpack_public_path__ + "static/media/estadoFlujoIcon.e9bd1675.svg";